<template>
	<form>
		<header class="mb-4">
			<h3 class="flex items-center">
				<strong>
					<a href="#" @click.prevent="backRegister">
						<feather-icon icon="ChevronLeftIcon"></feather-icon>
					</a>
				</strong><strong>Registrasi</strong>
			</h3>
		</header>
		<div class="form-group mb-4">
			<h5 class="block mb-2">
				Langkah 1
			</h5>
			<strong>Isi data lembaga sahabat</strong>
		</div>
		<!-- Jenis -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Jenis <span class="text-danger">*</span>
			</strong>
			<v-select
			    v-model="accountType"
			    :options="accountOptions"
			    class="w-full rounded"
			/>
		</div>
		<!-- / -->
		<!-- Nama -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Nama Lembaga <span class="text-danger">*</span>
			</strong>
			<vs-input
				:class="!errors.has('name') ? 'w-full mb-4' : 'w-full'"
			    v-model="name"
			    v-validate="'required'"
			    placeholder="Nama"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="name"
			    :danger="errors.has('name')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('name')">
				<strong>{{ errors.first('name') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Nama Pimpinan -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Nama Pimpinan <span class="text-danger">*</span>
			</strong>
			<vs-input
				:class="!errors.has('leader_name') ? 'w-full mb-4' : 'w-full'"
			    v-model="leader_name"
			    v-validate="'required'"
			    placeholder="Nama"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="leader_name"
			    :danger="errors.has('leader_name')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('leader_name')">
				<strong>{{ errors.first('leader_name') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Phone -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				No. Handphone/Whatsapp <span class="text-danger">*</span>
			</strong>
			<vs-input
				:class="!errors.has('no_telp') ? 'w-full mb-4' : 'w-full'"
			    v-model="no_telp"
			    v-validate="'required|min:10'"
			    placeholder="No. Handphone/Whatsapp"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="no_telp"
			    :danger="errors.has('no_telp')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('no_telp')">
				<strong>{{ errors.first('no_telp') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- NPWP -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				NPWP
			</strong>
			<vs-input
			    v-model="npwp"
			    placeholder="NPWP"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="npwp"
			/>
			<span class="text-danger text-sm" v-show="errors.has('npwp')">
				<strong>{{ errors.first('npwp') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- FAX -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				FAX
			</strong>
			<vs-input
			    v-model="fax"
			    placeholder="FAX"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="fax"
			/>
			<span class="text-danger text-sm" v-show="errors.has('fax')">
				<strong>{{ errors.first('fax') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- No.SK -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				No. SK
			</strong>
			<vs-input
				:class="!errors.has('no_sk') ? 'w-full mb-4' : 'w-full'"
			    v-model="no_sk"
			    placeholder="No. SK"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="no_sk"
			    :danger="errors.has('no_sk')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('no_sk')">
				<strong>{{ errors.first('no_sk') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Tanggal SK -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Tanggal SK
			</strong>
			<vs-input
				type="date"
				:class="!errors.has('tanggal_pengukuhan') ? 'w-full mb-4' : 'w-full'"
			    v-model="tanggal_pengukuhan"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="tanggal_pengukuhan"
			    :danger="errors.has('tanggal_pengukuhan')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('tanggal_pengukuhan')">
				<strong>{{ errors.first('tanggal_pengukuhan') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Website -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Website
			</strong>
			<vs-input
				:class="!errors.has('website') ? 'w-full mb-4' : 'w-full'"
			    v-model="website"
			    placeholder="Website"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="website"
			    :danger="errors.has('website')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('website')">
				<strong>{{ errors.first('website') }}</strong>
			</span>
		</div>
		<!-- / -->
		<!-- Provinsi -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Provinsi <span class="text-danger">*</span>
			</strong>
			<v-select
			    v-model="provinsi"
			    :options="provinsiOptions"
			    class="w-full rounded"
			/>
		</div>
		<!-- / -->
		<!-- Kabupaten/Kota -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Kabupaten/Kota <span class="text-danger">*</span>
			</strong>
			<v-select
			    v-model="kota"
			    :options="kotaOptions"
			    class="w-full rounded"
			/>
		</div>
		<!-- / -->
		<!-- Alamat -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Alamat <span class="text-danger">*</span>
			</strong>
			<vs-textarea
				:class="!errors.has('alamat') ? 'w-full mb-4' : 'w-full'"
			    v-model="alamat"
			    v-validate="'required'"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="alamat"
			    :danger="errors.has('alamat')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('alamat')">
				<strong>{{ errors.first('alamat') }}</strong>
			</span>
		</div>
		<!-- / -->

		<vs-divider class="my-8"></vs-divider>
		<div class="form-group mb-4">
			<h5 class="mb-2">Langkah 2:</h5>
			<strong>Pilih kategori lembaga sahabat</strong>
		</div>

		<!-- Kategori OPZ / Non OPZ -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Kategori <span class="text-danger">*</span>
			</strong>
			<v-select
			    v-model="status_lembaga"
			    :options="kategoriOptions"
			    class="w-full rounded"
			/>
		</div>
		<!-- / -->

		<vs-divider class="my-8"></vs-divider>

		<!-- Sub Kategori UPZ -->
		<div class="form-group mb-4" v-if="status_lembaga !== null && status_lembaga.key === 'non-opz'">
			<strong class="block mb-2">
				Kategori UPZ 
			</strong>
			<v-select
			    v-model="status_upz"
			    :options="upzOptions"
			    class="w-full rounded"
			/>
		</div>
		<!-- / -->

		<vs-divider v-if="status_lembaga !== null && status_lembaga.key === 'non-opz'" class="my-8"></vs-divider>

		<div class="form-group mb-4">
			<h5 class="mb-2">Langkah 3:</h5>
			<strong>Isi data PIC lembaga</strong>
		</div>

		<!-- Nama PIC -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Nama PIC <span class="text-danger">*</span>
			</strong>
			<vs-input
				:class="!errors.has('name_person') ? 'w-full mb-4' : 'w-full'"
			    v-model="name_person"
				v-validate="'required'"
			    placeholder="Nama PIC"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="name_person"
			    :danger="errors.has('name_person')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('name_person')">
				<strong>{{ errors.first('name_person') }}</strong>
			</span>
		</div>
		<!-- / -->

		<!-- No. Telpon -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				No. Telpon <span class="text-danger">*</span>
			</strong>
			<vs-input
				type="number"
				:class="!errors.has('no_telp_person') ? 'w-full mb-4' : 'w-full'"
			    v-model="no_telp_person"
				v-validate="'required|min:10|max:13'"
			    placeholder="No. Telpon"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="no_telp_person"
			    :danger="errors.has('no_telp_person')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('no_telp_person')">
				<strong>{{ errors.first('no_telp_person') }}</strong>
			</span>
		</div>
		<!-- / -->

		<!-- Email PIC -->
		<div class="form-group mb-4">
			<strong class="block mb-2">
				Email PIC <span class="text-danger">*</span>
			</strong>
			<vs-input
				:class="!errors.has('email_person') ? 'w-full mb-4' : 'w-full'"
			    v-model="email_person"
				v-validate="'required|email'"
			    placeholder="Email PIC"
			    class="w-full rounded"
			    @keyup.enter="register"
			    val-icon-danger="icon-x"
			    val-icon-pack="feather"
			    name="email_person"
			    :danger="errors.has('email_person')"
			/>
			<span class="text-danger text-sm" v-show="errors.has('email_person')">
				<strong>{{ errors.first('email_person') }}</strong>
			</span>
		</div>
		<!-- / -->

		<vs-divider class="my-8"></vs-divider>
		<vs-button color="primary" id="btn-submit" @click.prevent="submit" class="w-full rounded mb-6">Buat Akun</vs-button>
	</form>
</template>
<script>
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
import { mapState } from 'vuex'

const dict = {
  custom: {
    name: {
      required: 'Harap isi nama lembaga'
    },
    leader_name: {
      required: 'Harap isi nama pimpinan'
    },
    email: {
		required: 'Harap masukan email',
		email: 'Harap masukan email yang valid, contoh: yourmail@gmail.com'
	},
	no_telp: {
		required: 'Harap masukan nomer telepon anda',
		min: 'Nomer telepon minimal 11 angka'
	},
	password: {
		required: 'Harap masukan password',
		min: 'Password minimal 6 karakter'
	},
	confirm_password: {
		required: 'Harap masukan konfirmasi password',
		confirmed: 'Password tidak sama'
	},
	no_telp_person: {
		required: 'Harap isi no telepon PIC',
		min: 'Minimal no telepon 10 digit',
		max: 'Maksimal no telepon 13 digit'
	},
	alamat: {
		required: 'Harap isi alamat'
	},
	name_person: {
		required: 'Harap isi nama PIC'
	},
	email_person: {
		required: 'Harap isi email PIC',
		email: 'Harap masukan alamat email yang valid'
	}

  }
};

Validator.localize('en', dict)

export default {
	created() {
		const userData = {}
		Object.assign(userData, this.registeredData)

		this.name = userData.name
		this.email = userData.email
		this.no_telp = userData.no_telp
	},
  mounted () {
    this.getProvinsi()
  },
  computed: {
  	...mapState('auth', ['registeredData'])
  },
  watch: {
    provinsi (val) {
      this.getKota(val.id)
    }
  },
  components: {
    vSelect
  },
  data: () => ({
    name: null,
    email: null,
    leader_name: null,
    no_sk: null,
    name_person: null,
    email_person: null,
    no_telp_person: null,
    provinsi: null,
    kota: null,
    fax: null,
    npwp: null,
    zakat_perbulan: null,
    website: null,
    no_pengukuhan: null,
    tanggal_pengukuhan: null,
    status_lembaga: null,
    keterangan: '-',
    file_sk: null,
    file_sk_name: null,
    file_foto: null,
    file_foto_name: null,
    file_surat: null,
    file_surat_name: null,
    provinsiOptions: [],
    kotaOptions: [],
    alamat: null,
    no_telp: null,
    accountOptions: [{id: 3, label: 'Sahabat ZX'}],
    status_upz: {id: 1, label: 'Unit Pengumpul Zakat'},
	upzOptions: [
		{id: 1, label: 'Unit Pengumpul Zakat'},
		{id: 2, label: 'Mesjid'},
		{id: 3, label: 'Umum'}
	],
    kategoriOptions: [
    	{id: 1, label: 'Organisasi Pengelola Zakat', key: 'opz'},
    	{id: 2, label: 'Non Organisasi Pengelola Zakat', key: 'non-opz'}
    ],
    accountType: {id: 3, label: 'Sahabat ZX'}
  }),
  methods: {
  	backRegister() {
  		this.$emit('backRegister')
  	},
    setFileSurat () {
      const file = this.$refs['surat'].files[0]
      this.file_surat = file
      this.file_surat_name = file.name
      let arrFileName = file.name.split('.'),
        ext = arrFileName[arrFileName.length - 1].toLowerCase()

      if (!['pdf', 'docx', 'doc', 'jpg', 'png', 'jpeg', 'gif'].includes(ext)) {
        this.file_surat = null
        this.file_surat_name = null

        this.$vs.notify({
          title: 'File tidak diperbolehkan',
          text: 'Harap upload dokumen atau gambar',
          color: 'danger',
          position: 'top-right'
        })

        return false
      }
    },
    setFileFoto () {
      const file = this.$refs['foto'].files[0]
      this.file_foto = file
      this.file_foto_name = file.name
      let arrFileName = file.name.split('.'),
        ext = arrFileName[arrFileName.length - 1].toLowerCase()

      if (!['pdf', 'docx', 'doc', 'jpg', 'png', 'jpeg', 'gif'].includes(ext)) {
        this.file_foto = null
        this.file_foto_name = null

        this.$vs.notify({
          title: 'File tidak diperbolehkan',
          text: 'Harap upload dokumen atau gambar',
          color: 'danger',
          position: 'top-right'
        })

        return false
      }
    },
    setFileSK () {
      const file = this.$refs['sk_lembaga'].files[0]
      this.file_sk = file
      this.file_sk_name = file.name
      let arrFileName = file.name.split('.'),
        ext = arrFileName[arrFileName.length - 1].toLowerCase()

      if (!['pdf', 'docx', 'doc', 'jpg', 'png', 'jpeg', 'gif'].includes(ext)) {
        this.file_sk = null
        this.file_sk_name = null

        this.$vs.notify({
          title: 'File tidak diperbolehkan',
          text: 'Harap upload dokumen atau gambar',
          color: 'danger',
          position: 'top-right'
        })

        return false
      }
    },
    getKota (provinsi_id) {
      this.$vs.loading()
      this.$store.dispatch('region/getKota', {provinsi_id})
        .then(kota => {
          this.$vs.loading.close()
          kota.map(item => item.label = item.name)
          this.kotaOptions = kota
        })
        .catch(e => {
          this.$vs.loading.close()
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
    getProvinsi () {
      this.$store.dispatch('region/getProvinsi')
        .then(provinsi => {
          provinsi.map(item => item.label = item.name)
          this.provinsiOptions = provinsi
        })
        .catch(e => {
          console.error(e)
          if (e.response) {
            console.error(e.response)
          }

          return false
        })
    },
    submit () {
      if (this.accountType == null) {
        this.$vs.notify({
          title: 'Harap pilih peran pendaftar',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

      if(this.provinsi === null || this.kota === null) {
      	this.$vs.notify({
          title: 'Harap pilih provinsi dan kabupaten/kota',
          text: '',
          color: 'warning',
          position: 'top-right'
        })

        return false
      }

		if(this.status_lembaga === null ) {
			this.$vs.notify({
				title: 'Harap pilih kategori Sahabat ZX',
				text: '',
				color: 'warning',
				position: 'top-right'
			})

			return false
		}

		//   Validate if select non opz, and user not select upz category
		if(this.status_lembaga.key === 'non-opz') {
			if(this.status_upz === null){
				this.$vs.notify({
					title: 'Harap pilih kategori upz',
					text: '',
					color: 'warning',
					position: 'top-right'
				})

				return false
			}
		}

		this.$validator.validateAll().then((res) => {
			if (res) {

				// payload for /auth/register
				let payloadRegister = {}
				Object.assign(payloadRegister, this.registeredData)
				payloadRegister.jenis = 1

				// payload for mitra
				const payloadRegisterMitra = {
					user_id: 0, // change when register success
					status_upz: this.status_upz.id,
					status_lembaga: this.status_lembaga.id,
					name: this.leader_name,
					no_telp: this.no_telp,
					email: this.email,
					alamat: this.alamat
				};
				payloadRegister.no_telp = this.no_telp;

				if(this.tanggal_pengukuhan !== null) {
					const arrDate = this.tanggal_pengukuhan.split('-').reverse().join('/')

					payloadRegisterMitra.tanggal_Pengukuhan = arrDate
				}

				if(this.name_person !== null) {
					payloadRegisterMitra.name_person = this.name_person
				}

				if(this.no_telp_person !== null) {
					payloadRegisterMitra.no_telp_person = this.no_telp_person
				}

				if(this.email_person !== null) {
					payloadRegisterMitra.email_person = this.email_person
				}

				if(this.keterangan !== null) {
					payloadRegisterMitra.keterangan = this.keterangan
				}

				if(this.website !== null) {
					payloadRegisterMitra.website = this.website
				}

				if(this.npwp !== null) {
					payloadRegisterMitra.npwp = this.npwp
				}

				if(this.fax !== null) {
					payloadRegisterMitra.fax = this.fax
				}

				if(this.no_sk !== null) {
					payloadRegisterMitra.no_pengukuhan = this.no_sk
					payloadRegisterMitra.no_sk = this.no_sk
				}

				if(this.provinsi !== null) {
					payloadRegisterMitra.provinsi_id = this.provinsi.id
				}

				if(this.kota !== null) {
					payloadRegisterMitra.kabkot_id = this.kota.id
				}

				/**
				* FLOW
				* 1. Post to /auth/register
				* 2. get user_id and assign it to payloadRegisterMitar.user_id
				* 3. Upload file_sk, file_foto, file_surat to dev_storage/files and get each field response.data.link and assign to file_sk, file_kantor, file_penunjukan
				* 4. post to /input/data-lembaga
				* 5. Notify to login
				*/
				this.$vs.loading({
					container: '#btn-submit',
					scale: 0.5
				})

				this.$store.dispatch('auth/register', [payloadRegister])
					.then(user => {
					// Login to get token
					const fdd = new FormData()
					fdd.append('email', payloadRegister.email)
					fdd.append('password', payloadRegister.password)
					this.$store.dispatch('auth/login', fdd)
		            .then(() => {

		            	// Send data lembaga
						payloadRegisterMitra.user_id = user.id

						this.$store.dispatch('auth/registerMitra', [payloadRegisterMitra ])
						.then(() => {
							this.$vs.loading.close('#btn-submit > .con-vs-loading')
							this.$vs.notify({
								title: 'Pendaftaran Berhasil',
								text: 'Selamat Datang',
								color: 'success',
								position: 'top-right'
							})
							setTimeout(() => {
								window.location = '/home'
							}, 1500)
						})
						.catch(e => {
							this.$vs.loading.close('#btn-submit > .con-vs-loading')
							console.error(e)
							return false
						})
		            })
		            .catch(e => {
		              this.$vs.loading.close('#btn-submit > .con-vs-loading')
		              if (e.response) this.error = e.response.data.message

		              return false
		            })

				})
				.catch(e => {
					this.$vs.loading.close('#btn-submit > .con-vs-loading')
					if(e.response) {
						console.error(e.response.data)
						console.error(typeof e.response.data)
						const error = e.response

						if(typeof error.data === 'object') {
							for(let err in error.data) {

								console.error('wow', err)
								console.error('wow2', error.data[err])
								this.$vs.notify({
									time: 5000,
									title: 'Oops',
									text: error.data[err],
									color: 'danger',
									position: 'top-right'
								})
							}

							return false
						}
						else {
							this.$vs.notify({
								time: 5000,
								title: 'Oops',
								text: error.data.message,
								color: 'danger',
								position: 'top-right'
							})

							return false
						}
					}
					return false
				})
			} else {
			  return false
			}
						
		})
    }
  }
}
</script>